import classNames from "classnames";
import Radio from "~/common/components/Radio";
import { type ItemDef } from "~/common/types";

interface RadioSwitchProps {
  value: string;
  onChange: (newVal: string) => void;
  options: ItemDef[];
  className?: string;
  label?: string;
}

export const RadioSwitch = ({ className, label, options, value, onChange }: RadioSwitchProps) => {
  return (
    <div className={classNames("scha__radio-switch", className)}>
      {label && <label className={"scha__radio-switch__label"}>{label}</label>}
      <div className={"scha__radio-switch__options"}>
        {options.map((option) => (
          <div className={"scha__radio-switch__option"} onClick={() => onChange(option.code)}>
            <Radio active={value === option.code} className={"icon-margin"} />
            <span>{option.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
